import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{ background: "#283618" }}
      className="relative overflow-hidden"
    >
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3
                className="text-2xl font-medium mb-4"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  color: "#FCF8F6",
                }}
              >
                The Zumo Company
              </h3>
            <p
              className="text-sm leading-relaxed mb-6"
              style={{
                fontFamily: "'Manrope', sans-serif",
                color: "rgba(252, 248, 246, 0.6)",
              }}
            >
              Premium cold-pressed juices & wellness shots.
              <br />
              No Sugar. No Water. No Preservatives.
              <br />
              Crafted fresh daily in Doha, Qatar.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/thezumocompany/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                style={{ background: "rgba(252, 248, 246, 0.1)" }}
              >
                <Instagram size={18} color="#FCF8F6" />
              </a>
              <a
                href="https://wa.me/97466846261"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                style={{ background: "rgba(252, 248, 246, 0.1)" }}
              >
                <MessageCircle size={18} color="#FCF8F6" />
              </a>
              <a
                href="mailto:contact@thezumocompany.com"
                data-testid="footer-email"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                style={{ background: "rgba(252, 248, 246, 0.1)" }}
              >
                <Mail size={18} color="#FCF8F6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-xs uppercase tracking-[0.2em] font-semibold mb-6"
              style={{
                fontFamily: "'Manrope', sans-serif",
                color: "#A3B18A",
              }}
            >
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "About", path: "/about" },
                { label: "Products", path: "/products" },
                { label: "Zumo Points", path: "/zumo-points" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="text-sm transition-colors duration-300 hover:text-[#F0B7A4]"
                  style={{
                    fontFamily: "'Manrope', sans-serif",
                    color: "rgba(252, 248, 246, 0.6)",
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Promise */}
          <div>
            <h4
              className="text-xs uppercase tracking-[0.2em] font-semibold mb-6"
              style={{
                fontFamily: "'Manrope', sans-serif",
                color: "#A3B18A",
              }}
            >
              Our Promise
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                "100% Cold Pressed",
                "No Added Sugar",
                "No Added Water",
                "No Preservatives",
                "Same Day Freshness",
              ].map((item) => (
                <li
                  key={item}
                  className="text-sm flex items-center gap-2"
                  style={{
                    fontFamily: "'Manrope', sans-serif",
                    color: "rgba(252, 248, 246, 0.6)",
                  }}
                >
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ background: "#A3B18A" }}
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Giant brand name */}
      <div className="overflow-hidden border-t border-[rgba(252,248,246,0.08)]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-xs"
            style={{
              fontFamily: "'Manrope', sans-serif",
              color: "rgba(252, 248, 246, 0.35)",
            }}
          >
            &copy; {new Date().getFullYear()} The Zumo Company. All rights
            reserved.
          </p>
          <p
            className="text-[8vw] md:text-[4vw] font-medium leading-none select-none"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: "rgba(252, 248, 246, 0.06)",
            }}
          >
            ZUMO
          </p>
        </div>
      </div>
    </footer>
  );
}
